@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.header {
  margin: 0 0 5px;
}

.option-wrapper {
  @margin-right-between-options: 15px;

  display: flex;
  flex-wrap: wrap;
  margin: 0 -@margin-right-between-options 5px 0;

  .option {
    margin-right: @margin-right-between-options;
  }
}

.email-address-csv-textarea {
  min-height: 50px;
  overflow: auto;

  textarea {
    min-height: initial;
  }
}

.email-option-footer {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 10px;
}

.email-address-list-instructions {
  color: @return-label-dispatcher--text-color;
  font-size: 14px;
  font-style: italic;
  margin-bottom: 15px;
}
